<template>
  <FormSelect
    :name="$t('meta.containerGroup')"
    @input="$emit('input', $event)"
    :value="value"
    :disabled="disabled"
    :loading="!containerTypeGroupNames"
    :required="required"
    :options="groupOptions"
    data-testid="order-form__target-container-type-group-name-select"
  />
</template>

<script>
import FormSelect from '@/components/Form/Select/index.vue'

import containerTypeGroupNamesApi from '@/api/containers/type_group_names.js'

export default {
  name: 'ContainerGroupTypeNameSelect',
  components: { FormSelect },
  props: {
    value: { type: String, required: false },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
  },
  data: () => ({
    containerTypeGroupNames: null,
  }),
  computed: {
    groupOptions() {
      return this.containerTypeGroupNames?.map(containerTypeGroupName => ({
        label: containerTypeGroupName.text,
        value: containerTypeGroupName.name,
      }))
    },
  },
  async created() {
    this.containerTypeGroupNames = await containerTypeGroupNamesApi.getAll()
  },
}
</script>
